import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Copy = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1M16 12.9C16 9.4 14.6 8 11.1 8M16 12.9V16H17.1C20.6 16 22 14.6 22 11.1V6.9C22 3.4 20.6 2 17.1 2H12.9C9.4 2 8 3.4 8 6.9V8H11.1",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
